import React, { useCallback, useEffect, useState } from 'react';
import { fetchTerms } from '../../reducers/auth/auth.actions';
import { useDispatch, useSelector } from 'react-redux';

const Terms = () => {
  const dispatch = useDispatch();
  const [terms, setTerms] = useState();

  useEffect(() => {
    dispatch(fetchTerms()).then(resp => {
      setTerms(resp)
    })
  }, [dispatch]);
  return (
    <div className="container static-pages">
      {terms && (
        <>
          <h3 className="text-center mt-3">{ terms.title}</h3>
          <hr />
          <p>
            {terms.content}
          </p>
        </>
      )}
    </div>
  );
};

export default Terms;
